import { XYChart } from '@amcharts/amcharts5/xy';

import { setYAxisLabel } from 'features/Health/components/FrameHealthChart/utils/axisLabel/setYAxisLabel';
import { setSeries } from 'features/Health/components/FrameHealthChart/utils/setSeries';
import {
  cursorSettings,
  formattingSettings,
  getXYChartSettings,
  xAxisRendererSettings,
  xAxisSettings,
  yAxisRendererSettings,
  yAxisSettings,
} from 'features/Health/components/FrameHealthChart/utils/settings';
import { FrameHealthDimension } from 'features/Health/containers/FrameHealthChartContainer/types/frameHealthDimension';
import { am5Root, am5XYChart, categoryAxis, valueAxis } from 'utils/charts/charts';
import { setAxisRenderer } from 'utils/charts/setAxisRenderer';
import { setCursor } from 'utils/charts/setCursor';
import { setFormatting } from 'utils/charts/setFormatting';

export const initialiseChart = (
  chartId: string,
  chartData: FrameHealthDimension[],
  frameHealthDimension: string,
  amchartsLicenseKey: string
) => {
  const root = am5Root(chartId, amchartsLicenseKey);
  setFormatting(root, formattingSettings);

  const chart: XYChart = root.container.children.push(am5XYChart(root, getXYChartSettings()));
  setCursor(root, chart, cursorSettings);

  const yAxis = chart.yAxes.push(categoryAxis(root, yAxisSettings(root)));
  yAxis.data.setAll(chartData);
  const xAxis = chart.xAxes.push(valueAxis(root, xAxisSettings(root)));

  setAxisRenderer(yAxis, yAxisRendererSettings);
  setAxisRenderer(xAxis, xAxisRendererSettings);

  setYAxisLabel(yAxis, chartData);

  setSeries(root, chart, frameHealthDimension, yAxis, xAxis, chartData);
  chart.appear(1000, 100);
  return root;
};
